import React, {PureComponent} from 'react';
import './App.css';
import AuthenticationComponent from "./pages/authentication";
import Loggedin from "./pages/authentication/loggedin";
import Connect from "react-redux/es/connect/connect";
import {autoLogin} from "./actions";
import {withTranslation} from "react-i18next";
import {ToastContainer} from "react-toastify";
import {getItem, keys} from "./localStorage";
import {dispatchOnLogin, dispatchOnLoginFailure, dispatchOnLoginSuccess} from "./pages/authentication/functions";
import Config from './config';

class App extends PureComponent {

	componentDidMount() {
		this.onAutoLogin();
	}

	onAutoLogin = () => {
		if(getItem(keys.loggedIn) === null) return null;
		const postData = getItem(keys.personal_data);
		this.props.dispatchOnLogin();
		autoLogin(postData)
			.then(response => {
				this.props.dispatchOnLoginSuccess();
			})
			.catch(error => {
				this.props.dispatchOnLoginFailure();
			})
	};

	renderInitialScreen() {
		if (this.props.loggedIn) {
			return (
				<Loggedin/>
			)
		}
		return (
			<AuthenticationComponent />
		)
	}

	render() {
		return (
			<div>
				{this.renderInitialScreen()}
				<ToastContainer autoClose={8000} />
			</div>
		);
	}
}

const mapStateToProps = store => ({
	loggedIn: store.loginReducer.loggedIn,
});

const mapFunctionsToProps = {
	dispatchOnLogin,
	dispatchOnLoginSuccess,
	dispatchOnLoginFailure,
};

export default (Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(App)));
